import { useEffect } from 'react';
import {
  Route,
  Routes as RoutesContainer,
  useLocation,
} from 'react-router-dom';
import { AuthRoutes } from './auth/auth-routes';
import { CCFRoutes } from './ccf/ccf-routes';
import HomeRedirect from './components/layout/home-redirect';
import PageNotFound from './components/layout/page-not-found';
import { CustomRoute } from './components/layout/sidebar/components/route';
import { GroupRoutes } from './group/group-routes';
import { OnboardingRoutes, SignupRoutes } from './onboarding/onboarding-routes';
import { ReportRoutes } from './pages/reports/report-routes';
import SettingsPage from './pages/settings/settings-page';
import { PCFRoutes } from './pcf/pcf-routes';
import { PurchasedGoodsRoutes } from './purchased-goods/purchased-goods-routes';
import { useIntercom } from './services/intercom/IntercomContext';
import { SoldGoodsRoutes } from './sold-goods/sold-goods-routes';

function Routes() {
  const location = useLocation();
  const { updateIntercom } = useIntercom();

  useEffect(() => {
    updateIntercom({
      url: window.location.href,
    });
  }, [location, updateIntercom]);

  return (
    <RoutesContainer>
      <Route path="/" element={<CustomRoute element={<HomeRedirect />} />} />

      {PCFRoutes()}
      {ReportRoutes()}
      {CCFRoutes()}
      {PurchasedGoodsRoutes()}
      {SoldGoodsRoutes()}
      {GroupRoutes()}
      {OnboardingRoutes()}
      {SignupRoutes()}

      <Route
        path="/settings"
        element={<CustomRoute element={<SettingsPage />} requiresAuth />}
      />

      {AuthRoutes()}
      <Route path="*" element={<PageNotFound />} />
    </RoutesContainer>
  );
}

export default Routes;
